import React from 'react';
import { Card, Progress, Statistic, Row, Col } from 'antd';
import { 
  ProjectOutlined, 
  CreditCardOutlined, 
  DashboardOutlined,
  CheckCircleOutlined,
  ExclamationCircleOutlined 
} from '@ant-design/icons';
import PropTypes from 'prop-types';

const ContadoresWidget = ({ contadores }) => {
  if (!contadores) return null;

  const getStatusColor = (percentage) => {
    if (percentage >= 80) return '#52c41a'; // Verde
    if (percentage >= 50) return '#faad14'; // Amarillo
    return '#ff4d4f'; // Rojo
  };

  const getStatusIcon = (percentage) => {
    if (percentage >= 80) return <CheckCircleOutlined style={{ color: '#52c41a' }} />;
    return <ExclamationCircleOutlined style={{ color: '#faad14' }} />;
  };

  const formatNumber = (num) => {
    if (num >= 1000000) return `${(num / 1000000).toFixed(1)}M`;
    if (num >= 1000) return `${(num / 1000).toFixed(1)}K`;
    return num.toString();
  };

  return (
    <Card 
      title="Resumen del Sistema" 
      className="dashboard-widget dashboard-widget--contadores"
      extra={getStatusIcon((contadores.tarjetas.porcentajeActivo + contadores.sensores.porcentajeActivo) / 2)}
    >
      <Row gutter={[16, 16]}>
        {/* Proyectos */}
        <Col span={24}>
          <div className="contador-item">
            <div className="contador-item__icon">
              <ProjectOutlined />
            </div>
            <div className="contador-item__content">
              <Statistic 
                title="Proyectos Activos" 
                value={contadores.proyectos}
                formatter={(value) => formatNumber(value)}
              />
            </div>
          </div>
        </Col>

        {/* Tarjetas */}
        <Col span={24}>
          <div className="contador-item">
            <div className="contador-item__icon">
              <CreditCardOutlined />
            </div>
            <div className="contador-item__content">
              <div className="contador-item__stats">
                <Statistic 
                  title="Tarjetas" 
                  value={contadores.tarjetas.activas}
                  suffix={`/ ${formatNumber(contadores.tarjetas.total)}`}
                />
              </div>
              <div className="contador-item__progress">
                <Progress 
                  percent={contadores.tarjetas.porcentajeActivo} 
                  size="small"
                  strokeColor={getStatusColor(contadores.tarjetas.porcentajeActivo)}
                  format={(percent) => `${percent}%`}
                />
              </div>
            </div>
          </div>
        </Col>

        {/* Sensores */}
        <Col span={24}>
          <div className="contador-item">
            <div className="contador-item__icon">
              <DashboardOutlined />
            </div>
            <div className="contador-item__content">
              <div className="contador-item__stats">
                <Statistic 
                  title="Sensores" 
                  value={contadores.sensores.activos}
                  suffix={`/ ${formatNumber(contadores.sensores.total)}`}
                />
              </div>
              <div className="contador-item__progress">
                <Progress 
                  percent={contadores.sensores.porcentajeActivo} 
                  size="small"
                  strokeColor={getStatusColor(contadores.sensores.porcentajeActivo)}
                  format={(percent) => `${percent}%`}
                />
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <div className="contador-summary">
        <div className="contador-summary__item">
          <span>Estado del Sistema:</span>
          <span className="contador-summary__status" style={{ 
            color: getStatusColor((contadores.tarjetas.porcentajeActivo + contadores.sensores.porcentajeActivo) / 2) 
          }}>
            {((contadores.tarjetas.porcentajeActivo + contadores.sensores.porcentajeActivo) / 2) >= 80 ? 'Óptimo' : 
             ((contadores.tarjetas.porcentajeActivo + contadores.sensores.porcentajeActivo) / 2) >= 50 ? 'Aceptable' : 'Requiere Atención'}
          </span>
        </div>
      </div>
    </Card>
  );
};

ContadoresWidget.propTypes = {
  contadores: PropTypes.shape({
    proyectos: PropTypes.number.isRequired,
    tarjetas: PropTypes.shape({
      activas: PropTypes.number.isRequired,
      total: PropTypes.number.isRequired,
      porcentajeActivo: PropTypes.number.isRequired
    }).isRequired,
    sensores: PropTypes.shape({
      activos: PropTypes.number.isRequired,
      total: PropTypes.number.isRequired,
      porcentajeActivo: PropTypes.number.isRequired
    }).isRequired
  })
};

ContadoresWidget.defaultProps = {
  contadores: null
};

export default ContadoresWidget;
